import { useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function ConfirmDialog({ title, message, confirmLabel = 'Delete', working, onCancel, onConfirm }) {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape' && !working) onCancel();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onCancel, working]);

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && !working && onCancel()}>
      <section className="confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-message">
        <button className="icon-button confirm-dialog__close" type="button" onClick={onCancel} disabled={working} aria-label="Close confirmation"><X size={19} /></button>
        <span className="confirm-dialog__icon"><AlertTriangle size={24} /></span>
        <h2 id="confirm-title">{title}</h2>
        <p id="confirm-message">{message}</p>
        <div className="confirm-dialog__actions">
          <button className="button button--ghost" type="button" onClick={onCancel} disabled={working}>Cancel</button>
          <button className="button button--danger" type="button" onClick={onConfirm} disabled={working}>{working ? 'Deleting…' : confirmLabel}</button>
        </div>
      </section>
    </div>
  );
}
